import React from "react";
import IMG95 from "../../../assets/images/95-years.jpg"
import {Close} from "../../icons";
import AnimationButton from "./animation-button"
import { Years95 } from "../../icons"

const NewsletterNinetyFive = (props) => {
    return (
        <div className='newsletter newsletter-95'>
            <div className='newsletter__inner'>
                <div className='newsletter__wrapper'>
                    <button className='newsletter__close' onClick={() => props.onClick()}><Close color='#ffffff' /></button>
                    <div className='newsletter__image'>
                        <img src={IMG95} alt="Newsletter"/>
                        <Years95/>
                    </div>
                    <div className='newsletter__content'>
                        <h3>Quality always endures</h3>
                        <p>We’re celebrating 95 years of Edlyn. Join us as we look back on the incredible journey that’s taken us here.</p>

                        <AnimationButton className='btn btn--animation' to='/1929/'>Explore our Story</AnimationButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewsletterNinetyFive